import React from "react"
import { Box } from "@infotech/uikit-grid"
import LoaderBox from "src/components/forms/fragments/LoaderBox"
import styles from "./styles.css"

const PendingFiller = () => (
  <Box
    w="100%"
    pt="150"
    flex
    align="center"
    justify="center"
    className={styles.PendingFiller}
  >
    <LoaderBox color="#2880ff" size="big" />
  </Box>
)

export default PendingFiller
